import type { Iteration } from '@rhythmic/db/types'
import type { CreateIterationPayload } from '@rhythmic/types'
import { generateUuid, IterationSchema, UpdateIterationSchema } from '@rhythmic/types'
import type { Transaction } from '@tanstack/vue-db'
import { useRhythmicLogger } from '#imports'

import { getIterationsCollection } from '../../getCollections'

const logger = useRhythmicLogger('useTeamContext:createNewIteration')

export interface CreateNewIterationContext {
  workspace_id: string
  team_id: string
}

function validateParams(payload: CreateIterationPayload, context: CreateNewIterationContext) {
  const validatedPayload = UpdateIterationSchema.parse(payload)
  const id = generateUuid()
  logger.debug('Creating new iteration with ID', { id })
  const iteration = IterationSchema.parse({
    ...validatedPayload,
    workspace_id: context.workspace_id,
    team_id: context.team_id,
    id,
  })
  return iteration
}

export default function handleCreateNewIteration(
  payload: CreateIterationPayload,
  context: CreateNewIterationContext,
): Transaction<Iteration> | undefined {
  try {
    const iterationCollection = getIterationsCollection(context.team_id)
    const newIteration = validateParams(payload, context)
    logger.debug('Inserting new iteration', { newIteration })
    const transaction = iterationCollection.insert(newIteration) as Transaction<Iteration>
    return transaction
  } catch (error) {
    logger.error('createNewIteration failed', {
      error,
    })
  }
}
